export default "__VITE_ASSET__9db0d1d9__"